import React, { type FunctionComponent, useState } from 'react'
import styled from '@emotion/styled'
import { CheckboxWithLabel } from '@retailer-platform/shared-components'
import { DateRangePicker } from 'react-dates'
import { Global, css } from '@emotion/react'
import moment, { type Moment } from 'moment'
import { spacing } from '@retailer-platform/shared-components'

interface NotInAssortmentDatePickerProps {
  startTime: Date
  endTime: Date
  onTimeChange: (start: Date, end: Date) => void
}

interface DateRange {
  start: Moment | null
  end: Moment | null
}

const StartEndDates = styled.div({
  display: 'flex',
  flexDirection: 'row',
  gap: spacing.X16,
})

export const NotInAssortmentDatePicker: FunctionComponent<NotInAssortmentDatePickerProps> = ({
  startTime,
  endTime,
  onTimeChange,
}) => {
  const [dateRange, setDateRange] = useState<DateRange>({
    start: startTime ? moment(startTime) : null,
    end: endTime ? moment(endTime) : null,
  })
  const [noEndDate, setNoEndDate] = useState<boolean>(false)
  const [focusedInput, setFocusedInput] = useState(null)

  const updateNoEndDate = event => {
    const checked = event.target.checked
    if (event.target.checked) {
      setDateRange({
        ...dateRange,
        end: null,
      })
    }
    setNoEndDate(checked)
    onTimeChange(dateRange.start?.toDate(), null)
  }

  const onDatesChange = ({ startDate, endDate }) => {
    setDateRange({ start: startDate, end: endDate })
    onTimeChange(startDate?.toDate(), endDate?.toDate())
  }

  return (
    <React.Fragment>
      <Global
        styles={css`
          .DateRangePicker_picker {
            z-index: 100;
          }
        `}
      />
      <StartEndDates>
        <DateRangePicker
          startDate={dateRange.start}
          startDateId="start_date_picker"
          endDate={dateRange.end}
          endDateId="end_date_picker"
          onDatesChange={onDatesChange}
          focusedInput={focusedInput}
          onFocusChange={setFocusedInput}
          disabled={noEndDate ? 'endDate' : null}
          small
          showClearDates
          withPortal
        />
        <CheckboxWithLabel
          id={'not_in_assortment_no_enddate_checker'}
          label={'No end date'}
          checked={noEndDate}
          onChange={updateNoEndDate}
        />
      </StartEndDates>
    </React.Fragment>
  )
}
